// extracted by mini-css-extract-plugin
module.exports = {"select":"CustomAsyncSelect_select__sx6fS","error":"CustomAsyncSelect_error__142wS"};